import * as React from 'react';
import { useState } from 'react';
import { Button, Col,Container,FormFeedback,FormGroup,Input,Label,Modal,Row,} from 'reactstrap';
import {IGlobalContextProps,withGlobalContext,} from 'src/context/global.context';
import { resetPassword } from 'src/services';
import { isPassword } from 'src/utils/validation';
import { Svg } from '../Svg';


interface IResetPasswordModalProps {
  isOpen: boolean;
  resetPasswordToken: string;
  toggleResetPasswordTokenModal: () => void;
  toggleLoginModal: () => void;
}

const ResetPasswordTokenModal: React.SFC<
  IResetPasswordModalProps & IGlobalContextProps
> = ({
  isOpen,
  context,
  resetPasswordToken,
  toggleResetPasswordTokenModal,
  toggleLoginModal,
}) => {
  const [state, setState] = useState({
    confirmedPassword: '',
    invalid: false,
    isChanged: false,
    newPassword: '',
    resetPasswordToken,
  });
  const isValid = 
    (state.newPassword === state.confirmedPassword) &&
    (!!state.newPassword  &&   isPassword(state.newPassword))
  ;

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({ ...state, [(e.target as any).name]: (e.target as any).value });
  };

  const handleKeyDown = (e: React.KeyboardEvent<Element>) => {
    if (e.key === 'Enter') {
      handleResetPasswordToken();
    }
  };

  const handleResetPasswordToken = async () => {
    const { newPassword } = state;
    if (isValid) {
      const resetPasswordDto = {
        password: newPassword,
        resetPasswordToken,
      };
      const resetPasswordResponse = await resetPassword(resetPasswordDto);
      if (resetPasswordResponse) {
        context.updateUser();
        setState({
          ...state,
          confirmedPassword: '',
          isChanged: true,
          newPassword: '',
        });
      }
    } else {
      setState({ ...state, invalid: true });
    }
  };

  const doClick = () => {
    toggleResetPasswordTokenModal();
    toggleLoginModal();
    }

  return (
    <Modal className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleResetPasswordTokenModal}
        />
      </div>
      <div className='d-flex justify-content-between align-items-center pl-5 pr-5'>
        <h3>
          Réinitialisation
          <br />
          de mot de passe
        </h3>
      </div>
      {!state.isChanged ? (
        <Container className='p-5'>
          <FormGroup>
            <Label>
            Votre mot de passe doit contenir 8 caractères minimum avec au moins une majuscule, un chiffre et un caractère spécial
            </Label>
            <Input
              type='password'
              name='newPassword'
              placeholder='Nouveau mot de passe*'
              required={true}
              value={state.newPassword}
              onChange={handleChange}
              handleKeyDown={handleKeyDown}
              invalid={(state.invalid &&  !isPassword(state.newPassword) ) ||  (!!state.newPassword && !isPassword(state.newPassword))}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type='password'
              name='confirmedPassword'
              placeholder='Confirmer nouveau mot de passe*'
              required={true}
              value={state.confirmedPassword}
              onChange={handleChange}
              handleKeyDown={handleKeyDown}
              invalid={(state.invalid &&  !isPassword(state.confirmedPassword) ) ||  (!!state.confirmedPassword && !isPassword(state.confirmedPassword))}
            />
            <FormFeedback>
              Les deux mots de passe ne correspondent pas
            </FormFeedback>
          </FormGroup>
          <Row className='d-flex justify-content-end'>
            <Col xs='12'>
              <Button
                className='text-uppercase text-white bg-primary float-right border-0 mt-3'
                onClick={handleResetPasswordToken}
              >
                Valider
              </Button>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container className='p-5'>
          <FormGroup>
            <Label>Votre mot de passe a été changé avec succès !</Label>
            <Row className='d-flex justify-content-center'>
            <Col  xs='4'>
              <Button className='text-uppercase text-white bg-primary w-100 border-0 mt-3' onClick={doClick}>Connexion</Button>
            </Col>
          </Row>
          </FormGroup>
        </Container>
      )}
    </Modal>
  );
};

export const ResetPasswordTokenModalWithGlobalContext = withGlobalContext(
  ResetPasswordTokenModal
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/ResetPasswordTokenModal.tsx